import { getScribeHttpClients } from '@heidi/api/client';

import type {
  OnboardingScriptResponse,
  OnboardingV2AssetsResponse,
  SpecialtyTranscriptResponse,
} from '../../contracts';

export const getSpecialtyTranscript = (specialtyName: string, locale: string) => {
  return getScribeHttpClients().scribeHttp.get<SpecialtyTranscriptResponse>(
    `/specialties/transcript-by-name/${encodeURIComponent(specialtyName)}`,
    { params: { locale } }
  );
};

export const getSpecialtyOnboardingScript = (specialtyId: string) => {
  return getScribeHttpClients().scribeHttp.get<OnboardingScriptResponse>(
    `/specialties/${encodeURIComponent(specialtyId)}/onboarding-script`
  );
};

export const getSpecialtyOnboardingV2Assets = (
  specialtyName: string,
  locale?: string
) => {
  return getScribeHttpClients().scribeHttp.get<OnboardingV2AssetsResponse>(
    `/specialties/${encodeURIComponent(specialtyName)}/onboarding-v2-assets`,
    locale ? { params: { locale } } : undefined
  );
};
